import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#000000',
            light: '#2c2c2c',
            dark: '#000000',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#666666',
            light: '#999999',
            dark: '#333333',
            contrastText: '#ffffff',
        },
        background: {
            default: '#F9FAFB',
            paper: '#ffffff',
        },
        text: {
            primary: '#111827',
            secondary: '#4B5563',
        },
        divider: '#E5E7EB',
    },
    typography: {
        fontFamily: "'Inter', 'Roboto', sans-serif",
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 500 },
        h6: { fontWeight: 500 },
        button: {
            textTransform: 'none',
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px',
                    boxShadow: 'none',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                containedPrimary: {
                    backgroundColor: '#000000',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#222222',
                    },
                },
                outlinedPrimary: {
                    borderColor: '#000000',
                    color: '#000000',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        borderColor: '#000000',
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
            },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 8,
                        '& fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&:hover fieldset': {
                            borderColor: '#9CA3AF',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#000000',
                            borderWidth: '1px',
                        },
                    },
                    '& .MuiInputBase-input': {
                        padding: '8px 14px',
                        minHeight: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E5E7EB',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#9CA3AF',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#000000',
                        borderWidth: '1px',
                    },
                },
                input: {
                    padding: '8px 14px',
                    minHeight: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                }
            },
        },
        MuiSelect: {
            defaultProps: {
                size: 'small',
                variant: 'outlined',
            },
            styleOverrides: {
                select: {
                    padding: '8px 14px',
                    minHeight: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '14px',
                },
                outlined: {
                    transform: 'translate(14px, 12px) scale(1)',
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -6px) scale(0.75)',
                    },
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                    '&.Mui-selected': {
                        color: '#000000',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: '#000000',
                },
            },
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: '#000000 !important',
                        color: '#ffffff',
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                },
                outlined: {
                    borderColor: '#E5E7EB',
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#666666',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                },
            },
        },
    },
});

export default theme;
